import { Component } from '@angular/core';

@Component({
  selector: 'app-thankyou-popup',
  templateUrl: './thankyou-popup.component.html',
  styleUrls: ['./thankyou-popup.component.scss']
})
export class ThankyouPopupComponent {

  public close() {
    $('.thanku-popup').css('display', 'none');
  }
}
